import { render, staticRenderFns } from "./brandModal.vue?vue&type=template&id=7820f748&scoped=true&"
import script from "./brandModal.vue?vue&type=script&lang=js&"
export * from "./brandModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7820f748",
  null
  
)

export default component.exports